import { TextField, Button, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useFormik } from 'formik';
import { useAuth } from 'reactfire';
import { AuthError } from 'firebase/auth';
import * as yup from 'yup';

import { AuthContainer, AuthForm } from '../../styled/AuthPage.styled';
import { passwordRules } from '../../utils/passwordRules';
import { handleAuthError, resetPassword } from '../../utils/api/auth';

const resetPasswordSchema = yup.object().shape({
  password: yup
    .string()
    .min(8, 'Пароль має бути не коротшим ніж 8 символів')
    .required('Обов’язкове поле')
    .matches(passwordRules, 'Пароль занадто простий'),
  passwordConfirm: yup
    .string()
    .oneOf([yup.ref('password')], 'Паролі не співпадають')
    .required('Обов’язкове поле'),
});

const ResetPasswordPage = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const formik = useFormik({
    initialValues: {
      password: '',
      passwordConfirm: '',
    },
    validationSchema: resetPasswordSchema,
    async onSubmit({ password }, { setErrors }) {
      try {
        await resetPassword(auth, searchParams.get('oobCode') ?? '', password);

        navigate('/login');
      } catch (error) {
        const message = handleAuthError(error as AuthError);

        setErrors({ password: message });
      }
    },
  });

  return (
    <AuthContainer maxWidth="xs">
      <Typography variant="h5" marginBottom={3}>
        Зміна паролю
      </Typography>
      <AuthForm onSubmit={formik.handleSubmit}>
        <TextField
          id="password"
          name="password"
          type="password"
          label="Пароль"
          value={formik.values.password}
          onChange={formik.handleChange}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
        />
        <TextField
          id="passwordConfirm"
          name="passwordConfirm"
          type="password"
          label="Підтвердження паролю"
          value={formik.values.passwordConfirm}
          onChange={formik.handleChange}
          error={
            formik.touched.passwordConfirm &&
            Boolean(formik.errors.passwordConfirm)
          }
          helperText={
            formik.touched.passwordConfirm && formik.errors.passwordConfirm
          }
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={formik.isSubmitting}
        >
          Змінити пароль
        </Button>
      </AuthForm>
    </AuthContainer>
  );
};

export default ResetPasswordPage;
